export function Url(basePath) {
    const BasePath = basePath;
    return (path) => `${BasePath}${path ?? ""}`
}
export function ResponseResult({ succeeded, errors, value = null }) {
    this.Succeeded = succeeded ?? false;
    this.Value = value ?? null
    this.Errors = errors ?? [];
}

export function PaginationResult({ values = [], pageSize = 10, totalPages = 1, totalCount = 0, pageNumber = 1, hasNext = false, hasPrevious = false, search = '', sortColumn = null, sortOrder = null } = {}) {
    this.Values = values;
    this.TotalPages = totalPages;
    this.PageSize = pageSize;
    this.TotalCount = totalCount;
    this.PageNumber = pageNumber;
    this.HasNext = hasNext;
    this.HasPrevious = hasPrevious;
    this.Search = search;
    this.SortColumn = sortColumn;
    this.SortOrder = sortOrder;
    this.Request = null;

    this.ToPage = function (page) {
        if (page <= 0) return null
        if (page > this.TotalPages) return null

        // Callers that never set Request fall back to pagination-only fields, losing the
        // search filters — kept deliberately so they page exactly as they always have.
        const lastRequest = this.Request ?? new PaginationRequest({
            pageSize: this.PageSize,
            search: this.Search,
            sortColumn: this.SortColumn,
            sortOrder: this.SortOrder
        })

        return { ...lastRequest, pageNumber: page }
    }
}

export function PaginationRequest({ search = '', pageNumber = 1, pageSize = 10, sortColumn = null, sortOrder = null, tenantId } = {}) {
    this.search = search;
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    this.sortColumn = sortColumn;
    this.sortOrder = sortOrder;
    this.tenant = tenantId
}

export function GetBlobData({ data, headers }) {
    const blob = new Blob([data], { type: data.type })
    const contentDisposition = headers['content-disposition']
    let fileName = 'unknown'

    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (fileNameMatch.length > 1)
            fileName = fileNameMatch[1].replace(/['"]+/g, '');
    }

    return { blob, fileName }
}

export class EnumValue {
    constructor(value, name) {
        this.Value = value;
        this.Name = name;
    }

    static Unknown() {
        return new EnumValue(-1, 'Unknown')
    }
}

export function GroupBy(array, keySelector) {
    return array.reduce((map, item) => {
        const key = keySelector(item);
        if (!map.has(key)) { map.set(key, []) }
        map.get(key).push(item);
        return map;
    }, new Map());
}

export function UniqueId() {
    return "id" + Math.random().toString(16).slice(2)
}

// Composite grouping token for protocol visit-tracking inventory movements.
// Same value MUST feed both the move-request Relation.RelatedId and the
// PriorProtocolDispenses query param so they never diverge.
export function buildVisitTrackingRelationId(medicalRecordNumber, protocolId) {
    return `visittracking-${medicalRecordNumber}-${protocolId}`;
}

// Visit date -> yyyyMMdd int (Year*10000 + Month*100 + Day). Ordering key for
// Relation.SequenceNumber; day granularity, no timestamp.
export function dateToSequenceNumber(date) {
    if (date == null) return 0;
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return 0;
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
}